module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_8017.76538fe4.png";